import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { createGlobalStyle } from "styled-components"
import TopMenu from "../components/TopMenu/TopMenu"
import Footer from "../components/Footer/Footer"
import "animate.css/animate.min.css"
import ScrollAnimation from "react-animate-on-scroll"

const GlobalStyle = createGlobalStyle`

    html {
        scroll-behavior: smooth;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: "Montserrat", sans-serif;
    }

    main {
    }

    .columns-wrapper {
        display: flex;
        flex-direction: row;
    }

    .hidden { //fixchange hero triangle opacity
        & ::after {
            opacity: 0;
        }
    }

    .show {
        display: flex;
        opacity: 1;
        visibility: visible;
    }
`

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Montserrat:300,400,700|Poppins:300,400,700&display=swap&subset=latin-ext"
          rel="stylesheet"
        ></link>
      </Helmet>
      {/* <ScrollAnimation animateIn="fadeIn" duration={0.0001}> */}
      <GlobalStyle />
      <TopMenu />
      <main>{children}</main>
      <Footer />
      {/* </ScrollAnimation> */}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
